import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, setToken, clearToken } from "@/lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [state, setState] = useState(null); // subscription state
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const t = localStorage.getItem("dynaqr_token");
    if (!t) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const data = await api.me();
      setUser(data.user);
      setState(data.state);
    } catch {
      clearToken();
      setUser(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const login = async (email, password) => {
    const data = await api.login({ email, password });
    setToken(data.token);
    setUser(data.user);
    const me = await api.me();
    setState(me.state);
    return data.user;
  };

  const register = async (form) => {
    const data = await api.register(form);
    setToken(data.token);
    setUser(data.user);
    const me = await api.me();
    setState(me.state);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
    setState(null);
  };

  const refresh = load;

  return (
    <AuthContext.Provider value={{ user, state, loading, login, register, logout, refresh, setState }}>
      {children}
    </AuthContext.Provider>
  );
}
